import posthog from 'posthog-js'

const POSTHOG_PROJECT_TOKEN = 'phc_AJxznyTv5USykWxGyQokVH3aSrfGncMtvVMQSP3YJi7p'
const POSTHOG_HOST = 'https://eu.i.posthog.com'

let hasInitialized = false

export const initPosthog = (): void => {
  if (typeof window === 'undefined' || hasInitialized) {
    return
  }

  posthog.init(POSTHOG_PROJECT_TOKEN, {
    api_host: POSTHOG_HOST,
    defaults: '2026-05-30'
  })
  posthog.register({
    app: 'dealer_web',
    platform: 'web'
  })
  hasInitialized = true
}

export const isPosthogReady = (): boolean => hasInitialized
